import { DateFnsConfigurationService } from 'ngx-date-fns';
// Load date-fns french locale
import { fr } from 'date-fns/locale';
const frenchConfig = new DateFnsConfigurationService();
frenchConfig.setLocale(fr);
const ɵ0 = frenchConfig;
export class AppModule {
}
export { ɵ0 };
